var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"none"}},[_c('p',[_vm._v("You have left this browser idle for 3 second.")]),_c('p',[_vm._v(_vm._s(_vm.second)+" second left")])])}
var staticRenderFns = []

export { render, staticRenderFns }